import React from "react";
import NewNavbar from "../../Components/newNavbar/NewNavbar";
import Footer from "../../Components/footer/Footer";
import Outsidenavbar from "../outsideNavBar/OutSideNavBar";

const TermAndCondition = () => {
  return (
    <div className="d-flex flex-column min-vh-100 bg-white">
      {/* <NewNavbar /> */}
      <Outsidenavbar />

      <main className="custom-container my-5 flex-grow-1 text-start">
        <h1 className="fw-bold">Terms and Conditions</h1>
        <p className=" mb-4">Last Updated April 08, 2021</p>

        <section className="mb-4">
          <h4 className="font-semibold">Acceptance of Terms</h4>
          <p>
            By accessing and using our services, you agree to comply with the
            terms and conditions outlined in this document. If you do not agree,
            you should not use our services.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="font-semibold">Modifications</h4>
          <p>
            We reserve the right to change or modify these terms at any time.
            Changes will be effective immediately upon posting on our website.
            Your continued use of our services constitutes your acceptance of
            the modified terms.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="font-semibold">Limitation of Liability</h4>
          <p>
            In no event shall we be liable for any direct, indirect, incidental,
            special, or consequential damages resulting from your use of our
            services.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="font-semibold">Return & Refund Policy</h4>
          <p>
            Thank you for your purchase. We hope you are happy with your
            purchase. However, if you are not completely satisfied, you may
            return it to us for an exchange only. Please see below for more
            information on our return and refund policy.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="font-semibold">Returns</h4>
          <p>
            All returns must be postmarked within 3 months of purchase date. All
            returned items must have all original labels and seal attached.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="font-semibold">Return Process</h4>
          <p>
            To return an item, place the item securely in its original
            packaging, and mail your return to the following address:
          </p>
          <div
            className="bg-light p-3 rounded shadow-sm"
            style={{
              maxWidth: "30%",
              backgroundColor: "#f8f9fa",
            }}
          >
            <p className="mb-0">
              Pyramid Electronics
              <br />
              Attn: Returns <br />
              Plot No. 36, Sector 5, Parwanoo
              <br />
              Parwanoo, Himachal Pradesh 173220
              <br />
              India
            </p>
          </div>
          <br />

          <p>
            Please note you are responsible for all return and shipping charges.
            We strongly recommend that you use a trackable method to mail your
            return.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="font-semibold">Refund</h4>
          <p>
            After receiving your return and inspecting the condition of your
            item, we will process your exchange. Please allow at least 7 days
            from the receipt of your item to process your exchange.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="font-semibold">Exception</h4>
          <p>
            For defective or damaged products, please contact us at the contact
            details below to arrange an exchange. If you have any queries
            concerning our return policy, mail at{" "}
            <a href="mailto:sales@pyramidelectronics.in">
              sales@pyramidelectronics.in
            </a>
            .
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default TermAndCondition;
